import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

export const PlacementAgentsAPI = (baseURL: string |undefined, baseURLExternal: string |undefined, clientId: string) => {
    const apiConfig = {
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    };
    const externalAPI = AxiosAPI({ ...apiConfig, baseURL: baseURLExternal });
    const bookbuildingAPI = AxiosAPI({ ...apiConfig });

    const get = () => {
        const serviceUrl = `/Bank/GetAllBanks`;
        return externalAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getInstitutions = () => {
        const serviceUrl = `/bookbuilding-api/Institution/GetInstitutionValues`;
        return bookbuildingAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

	const getExternalContractInvestors = () => {
		const serviceUrl = `/bookbuilding-api/ExternalContracts/GetExternalContractInvestors`;
		return bookbuildingAPI.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	}

    return {
        get,
        getInstitutions,
		getExternalContractInvestors
    };
};